class VideoStepsModal {
    constructor(section) {
        this.root = section;
        if (!this.root) return;

        this.triggers = Array.from(
            this.root.querySelectorAll('[data-video-steps-trigger]')
        );
        this.modal = this.root.querySelector('[data-video-steps-modal]');
        this.dialog = this.root.querySelector('[data-video-steps-dialog]');
        this.iframe = this.root.querySelector('[data-video-steps-iframe]');
        this.closeButtons = Array.from(
            this.root.querySelectorAll('[data-video-steps-close]')
        );

        if (!this.triggers.length || !this.modal || !this.dialog || !this.iframe)
            return;

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.closeTimeout = null;

        this.triggers.forEach(trigger =>
            trigger.addEventListener('click', this.onTriggerClick)
        );
        this.closeButtons.forEach(button =>
            button.addEventListener('click', this.onCloseClick)
        );
    }

    onTriggerClick(event) {
        event.preventDefault();
        const trigger = event.currentTarget;
        const videoId = trigger.dataset.videoId || '';
        const videoUrl = trigger.dataset.videoUrl || '';
        const embedUrl = this.buildEmbedUrl(videoId, videoUrl);
        if (!embedUrl) return;
        this.open(embedUrl);
    }

    onCloseClick(event) {
        event.preventDefault();
        this.close();
    }

    onKeyDown(event) {
        if (event.key === 'Escape') {
            this.close();
        }
    }

    buildEmbedUrl(id, url) {
        const videoId = id || this.extractYoutubeId(url);
        if (!videoId) return '';
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }

    extractYoutubeId(url) {
        if (!url) return '';
        try {
            const parsed = new URL(url, window.location.origin);
            const host = parsed.hostname || '';
            if (host.includes('youtu.be')) {
                return parsed.pathname.replace('/', '');
            }
            if (host.includes('youtube.com') || host.includes('youtube-nocookie.com')) {
                const videoId = parsed.searchParams.get('v');
                if (videoId) return videoId;
                const parts = parsed.pathname.split('/').filter(Boolean);
                if (parts[0] === 'embed' && parts[1]) return parts[1];
                if (parts[0] === 'shorts' && parts[1]) return parts[1];
            }
        } catch (error) {
            return '';
        }
        return '';
    }

    open(embedUrl) {
        this.iframe.src = embedUrl;
        this.modal.classList.remove('hidden');
        window.requestAnimationFrame(() => {
            this.modal.classList.remove('opacity-0');
            this.modal.classList.add('opacity-100');
            this.dialog.classList.remove('translate-y-3', 'scale-[0.98]');
            this.dialog.classList.add('translate-y-0', 'scale-100');
        });
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.onKeyDown);
    }

    close() {
        if (this.closeTimeout) {
            window.clearTimeout(this.closeTimeout);
        }
        this.modal.classList.remove('opacity-100');
        this.modal.classList.add('opacity-0');
        this.dialog.classList.remove('translate-y-0', 'scale-100');
        this.dialog.classList.add('translate-y-3', 'scale-[0.98]');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.onKeyDown);

        this.closeTimeout = window.setTimeout(() => {
            this.iframe.src = '';
            this.modal.classList.add('hidden');
        }, 200);
    }
}

const initVideoSteps = () => {
    const sections = document.querySelectorAll('[data-video-steps]');
    if (!sections.length) return;
    sections.forEach(section => new VideoStepsModal(section));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoSteps);
} else {
    initVideoSteps();
}
